import { useDebouncedValue } from '@octanner/prism-core';
import * as React from 'react';
export default {
  useDebouncedValue,
  React
};